/** @jsx jsx */
import { jsx, Container } from "theme-ui"
import Header from "./header"
import Footer from "./footer"
import background from "../images/background.jpg"
import formesAssociations from "../images/formes-associations.png"

export default function Layout({ children }) {
  return (
    <div
      sx={{
        display: 'flex',
        flexDirection: 'column',
        minHeight: '100vh',
        background: `url(${formesAssociations}) top center no-repeat, url(${background}) repeat black`
      }}>
      <Header sx={{ width: '100%', mb: 16}} />
      <main
        sx={{
          width: '100%',
          flex: '1 1 auto',
        }}>
        <Container px={3}>
          {children}
        </Container>
      </main>
      <Footer sx={{width: '100%', mt: 4}} />
    </div>
  )
}
